












































	import Vue from "vue";
    import Calendar from "../Calendar.vue";
    import OrderService from "../../order.service"

	export default Vue.extend({
		props: ['countPeriod', 'date', 'settings', 'period', 'statusselect'],
        data() {
			return {
                calendar: {
				    disabled: [],
                    value_from: '',
                    value_to: '',
                    format: 'dd.MM.yyyy',
                },
                statusAll: OrderService.getStatusAll(),
			}
        },
        mounted() {
            this.setCalendar()
        },
        watch: {
            date() {
                this.setCalendar()
            }
        },
        methods: {
            setCalendar() {
                this.calendar.value_from = this.stringify(this.parse(this.date.from, 'yyyy-MM-dd'))
                this.calendar.value_to = this.stringify(this.parse(this.date.to, 'yyyy-MM-dd'))
            },
            setDate(date: Date, end: boolean) {
                let value_from = this.calendar.value_from
                let value_to = this.calendar.value_to
                end = end || false;
                let now = new Date()
                date = date > now ? now : date
                if (end) {
                    this.calendar.value_to = this.stringify(date)
                    this.$emit('updateDate', this.stringify(date, 'yyyy-MM-dd'), true)
                    if (+date - +this.parse(this.calendar.value_from, this.calendar.format) <= 0) {
                        let newDay = new Date(+this.parse(this.calendar.value_to, this.calendar.format) - 86400000)
                        this.calendar.value_from = this.stringify(newDay)
                        this.$emit('updateDate', this.stringify(newDay, 'yyyy-MM-dd'), false)
                    }
                } else {
                    this.calendar.value_from = this.stringify(date)
                    this.$emit('updateDate', this.stringify(date, 'yyyy-MM-dd'), false)
                    if (+date - +this.parse(this.calendar.value_to, this.calendar.format) >= 0) {
                        let newDay = new Date(+this.parse(this.calendar.value_from, this.calendar.format) + 86400000)

                        if (newDay > now) {
                            newDay = now
                            let fromDate = new Date(+newDay - 86400000)
                            this.calendar.value_from = this.stringify(fromDate)
                            this.$emit('updateDate', this.stringify(fromDate, 'yyyy-MM-dd'), false)
                        }

                        this.calendar.value_to = this.stringify(newDay)
                        this.$emit('updateDate', this.stringify(newDay, 'yyyy-MM-dd'), true)
                    }
                }

                if (value_from != this.calendar.value_from || value_to != this.calendar.value_to) {
                    this.$emit('update')
                }
            },
            selectPeriod(period: string) {
                if (period == this.period)
                {
                    return;
                }
                this.$emit('selectPeriod', period)
                this.$emit('update')
            },
            selectStatus(statusselect: number|string) {
                if (statusselect == this.statusselect)
                {
                    return;
                }
                this.$emit('selectStatus', statusselect)
                this.$emit('update')
            },
            stringify(date: Date, format?: string) {
                const date_format = format || this.calendar.format
                const year = date.getFullYear()
                const month = date.getMonth() + 1
                const day = date.getDate()
                return date_format
                    .replace(/yyyy/g, year.toString())
                    .replace(/MM/g, ('0' + month).slice(-2))
                    .replace(/dd/g, ('0' + day).slice(-2))
                    .replace(/yy/g, year.toString())
                    .replace(/M(?!a)/g, month.toString())
                    .replace(/d/g, day.toString())
            },
            parse(str?: string, format?: string): Date {
                if (!str) {
                    return new Date()
                }
                let date: Date = new Date()
                if (format == 'yyyy-MM-dd')
                {
                    date = new Date(+str.substring(0, 4), +str.substring(5, 7) - 1, +str.substring(8, 10))
                }
                else if (str.length === 10 && (format === 'dd-MM-yyyy' || format === 'dd/MM/yyyy' || format === 'dd.MM.yyyy')) {
                        date = new Date(+str.substring(6, 10), +str.substring(3, 5) - 1, +str.substring(0, 2))
                }
                return isNaN(date.getFullYear()) ? new Date() : date
            },
        },
        components: {
            Calendar,
        }
	})



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/backend/components/toolbar/Toolbar.vue